import { BaseCalendarModel, BaseCalendarProperties } from './base-calendar.model';
import { CalendarZoomFactors, MonthOrdinal } from '../../../features/calendar/calendar-types';
import { DateTimeHelper } from '../../../features/calendar/util/date-time-helper';
import { CalendarConfigModel } from '../app-config/calendar-config.model';
import { GlobalAppConfigModel } from '../app-config/global-app-config.model';

export class DayOrWeekCalendarModel extends BaseCalendarModel {
  public fixIntervalCalendarModel = new FixIntervalDayOrWeekCalendarModel();
  public readonly calendarProperties = new DayOrWeekCalendarProperties();

  constructor(calendarOptions?: CalendarConfigModel, globalAppConfigModel?: GlobalAppConfigModel) {
    super();
    if (!calendarOptions) {
      return;
    }

    this.calendarProperties.hoursOfDay = calendarOptions.hoursOfDay;
    this.calendarProperties.weekStartsOn = globalAppConfigModel.weekStartsOn;
    this.calendarProperties.timeFormat = calendarOptions.timeFormat;
    this.calendarProperties.timeBlockDraggingDuration = calendarOptions.timeBlockDraggingDuration;
    this.calendarProperties.minimumTimeBlockDuration = calendarOptions.minimumTimeBlockDuration;
    const today = new Date();
    this.calendarProperties.month = today.getMonth() as MonthOrdinal;
    this.calendarProperties.year = today.getFullYear();
    this.calendarProperties.workTimeStart = DateTimeHelper.timeStringToDate(
      globalAppConfigModel.workTimeStart,
    );
    this.calendarProperties.workTimeEnd = DateTimeHelper.timeStringToDate(
      globalAppConfigModel.workTimeEnd,
    );
    this.calendarProperties.zoomFactor = calendarOptions.zoomFactor;
  }
}

class DayOrWeekCalendarProperties extends BaseCalendarProperties {
  public timeBlockDraggingDuration: number; // In minutes
  public hoursOfDay: number;
  public zoomFactor: CalendarZoomFactors;
}

class FixIntervalDayOrWeekCalendarModel extends BaseCalendarModel {
  public highestParallelIndex: number;
}
